import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

const Menu = animated(styled.div`
  grid-area: menu;
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 0.75rem;
`);

export default props => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {animation => <Menu {...props} style={animation} />}
  </Spring>
);
